import { useCallback } from "react";
import { useWeb3React } from "@web3-react/core";
import useWeb3 from "../useWeb3";
import {
  getBalance,
  getLiquidityPool,
  CrashGameContract,
} from "../../utils/contractHelpers";
import {
  USDT_CONTRACT_ADDRESS,
  LUCKIFY_CONTRACT_ADDRESS,
  CRASH_GAME_CONTRACT,
} from "../../utils/Enviroment";
import Web3 from "web3";

export const GameAllCalls = () => {
  const web3 = new Web3(
    "https://dimensional-serene-wish.base-mainnet.quiknode.pro/384f047fe7195b52a94e84a42dbc1cc3541a48e5/"
  );
  const { account } = useWeb3React();
  // const web3 = useWeb3();
  let contract;

  const GameCurrentIndexHood = useCallback(
    async (accountsend) => {
      try {
        contract = await CrashGameContract(CRASH_GAME_CONTRACT, web3);
        const allowance = await contract.methods.currentIndex().call();
        return allowance;
      } catch (error) {
        console.error("Check Allowance error:", error);
        throw error;
      }
    },
    [account, contract, web3]
  );
  const GameRoundHook = useCallback(
    async (index) => {
      try {
        contract = await CrashGameContract(CRASH_GAME_CONTRACT, web3);
        const allowance = await contract.methods.rounds(index).call();
        return allowance;
      } catch (error) {
        console.error("Check Allowance error:", error);
        throw error;
      }
    },
    [account, contract, web3]
  );

  const GamePendingHook = useCallback(
    async (addrss, index) => {
      try {
        contract = await CrashGameContract(CRASH_GAME_CONTRACT, web3);
        const allowance = await contract.methods
          .crashPendingBets(addrss, index)
          .call();
        return allowance;
      } catch (error) {
        console.error("Check Allowance error:", error);
        throw error;
      }
    },
    [account, contract, web3]
  );

  return {
    GameCurrentIndexHood,
    GamePendingHook,
    GameRoundHook,
  };
};
